module.exports = __webpack_public_path__ + "img/img2.a702c7e9.svg";